import React from 'react';
import { WebDashboardsCell, WebLaunchersCell } from '../components';

/**
 * Build column definitions for Web Teams page
 */
export function buildWebTeamsColumnDefs({
  dashboardsById,
  launchersById,
  setDialog,
  addHomepageMenuItems,
  onMenuItemClick
}) {
  return [
    {
      id: 'teamLabel',
      displayName: 'Teams',
      width: 240,
      fixed: true,
      isLastFixedColumn: true,
      customHeaderCellStyle: 'coach-teams-column'
    },
    {
      id: 'dashboards',
      displayName: 'Dashboards',
      width: 480,
      CellRenderer: ({ record }) => (
        <WebDashboardsCell
          data={record}
          dashboardsById={dashboardsById}
          setDialog={setDialog}
          addHomepageMenuItems={addHomepageMenuItems}
          onMenuItemClick={onMenuItemClick}
        />
      ),
      customHeaderCellStyle: 'coach-homepages-column'
    },
    {
      id: 'launcher',
      displayName: 'Launchers',
      width: 323,
      CellRenderer: ({ record }) => (
        <WebLaunchersCell data={record} launchersById={launchersById} />
      ),
      customHeaderCellStyle: 'coach-menus-column'
    }
  ];
}
